import { useMutation } from "@tanstack/react-query";
import { toast } from "@/hooks/use-toast";
import { supabase } from "@/integrations/supabase/client";

export type HospitalityApplicationData = {
  fullName: string;
  email: string;
  phone?: string;
  school: string;
  graduationYear: string;
  restaurantName: string;
  restaurantOpeningDate: string;
  city: string;
  message?: string;
  honeypot?: string;
};

export const useHospitalityApplication = () => {
  return useMutation({
    mutationFn: async (data: HospitalityApplicationData) => {
      const { data: response, error } = await supabase.functions.invoke(
        "send-hospitality-application",
        { body: data }
      );

      if (error) {
        throw new Error(error.message || "Erreur lors de l'envoi");
      }

      return response;
    },
    onSuccess: () => {
      toast({
        title: "Candidature envoyée !",
        description: "Tu recevras un email de confirmation, nous revenons vers toi sous 3 jours.",
      });
    },
    onError: (error: Error) => {
      toast({
        title: "Erreur",
        description: error.message || "Une erreur s'est produite. Réessaie dans un instant.",
        variant: "destructive",
      });
    },
  });
};
